module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"confirmIdentity":"Confirmar Identidad","code":"Código","pin":"PIN","verificationError":"Codigo y/o pin no correctos, vuelve a intentarlo","verify":"Verificar","cancel":"Cancelar"},"en":{"confirmIdentity":"Confirm Identity","code":"Code","pin":"PIN","verificationError":"Incorrect code and/or pin, try again","verify":"Verify","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
